import { useGetRelease } from 'pages/Distribution/hooks';
import distributionApi from 'services/api/distribution';
import { ReleaseInfo, ReleaseInfoLoader } from './components';

type PropsType = {
  releaseId: string;
};

const ContentContainer = ({ releaseId }: PropsType) => {
  const { currentRelease } = useGetRelease(releaseId);
  const { isLoading: genresLoading, isError: genresError } =
    distributionApi.useGetGenresQuery();

  const isReady = currentRelease && !genresLoading && !genresError;
  if (!isReady) {
    return <ReleaseInfoLoader />;
  }

  return <ReleaseInfo releaseId={releaseId} />;
};

export default ContentContainer;
